import { QueryClient } from '@tanstack/react-query';

/**
 * Single app-wide QueryClient (COL-88). Defaults are react-query's own
 * (staleTime: 0, refetchOnWindowFocus: true) — that combination is exactly
 * what this ticket needs and nothing more needs overriding:
 *   - staleTime 0 + cache-first rendering means a page revisit paints the
 *     previous data instantly (no skeleton) while a revalidation fetch runs
 *     quietly in the background — "instant page switches from cache".
 *   - refetchOnWindowFocus true means an already-open tab picks up
 *     something captured elsewhere (phone, second tab) as soon as it
 *     regains focus, without a manual reload.
 *
 * User-scoping lives in queries/keys.js; the belt-and-braces cache wipe on
 * a detected user change lives in contexts/AuthContext.jsx (it needs
 * useAuth, which this module-level singleton doesn't have access to).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
    },
  },
});
